import { render, staticRenderFns } from "./TabelaPacoteServico.vue?vue&type=template&id=488cd32f"
import script from "./TabelaPacoteServico.vue?vue&type=script&lang=js"
export * from "./TabelaPacoteServico.vue?vue&type=script&lang=js"
import style0 from "./TabelaPacoteServico.vue?vue&type=style&index=0&id=488cd32f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports